﻿import React from 'react';
import classNames from 'classnames';
import { InputGroup, Spinner } from "@blueprintjs/core";
import PropTypes from 'prop-types';
import { ShowHide } from "components/layout";

import { FormHelperText } from "components/form-fields";
import 'components/form-fields/FormFields.css';


export function FormTextInput(
    {
        id = null,
        value = "",
        loading = false,
        headingText = null,
        helperText = null,
        disabled = false,
        dangerHelperText = null,
        placeholder = "",
        large = false,
        icon = null,
        type = "text",
        minLength = null,
        maxLength = null,
        showLoader = false,
        wide = false,
        reallyWide = false,
        ultraWide = false,
        fill = false,
        inputRef,
        onChange,
        onKeyPress
    }
) {

    let size;
    if (large) {
        size = "large";
    }

    return (
        <div className="form-field">
            <ShowHide
                evaluator={headingText != null}
                show={(
                    <h4 className={classNames({ "bp6-skeleton": loading })}>{headingText}</h4>
                )}
            />
            <FormHelperText loading={loading}>{helperText}</FormHelperText>
            <div className={classNames({ "inline-items": showLoader })}>
                <InputGroup
                    id={id}
                    className={classNames({ "bp6-skeleton": loading, "wide": wide, "really-wide": reallyWide, "ultra-wide": ultraWide, "fill": fill })}
                    disabled={disabled}
                    readOnly={onChange == null}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    size={size}
                    leftIcon={icon}
                    inputRef={inputRef}
                    type={type}
                    onKeyDown={onKeyPress}
                    minLength={minLength}
                    maxLength={maxLength}
                    autoComplete="off"
                />
                <ShowHide
                    evaluator={showLoader}
                    show={(
                        <div className="save-loader">
                            <Spinner size="25" />
                        </div>
                    )}
                />

            </div>
            <FormHelperText loading={loading} danger={true}>{dangerHelperText}</FormHelperText>
        </div>
    );
}

FormTextInput.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    loading: PropTypes.bool,
    headingText: PropTypes.string,
    helperText: PropTypes.node,
    disabled: PropTypes.bool,
    dangerHelperText: PropTypes.node,
    placeholder: PropTypes.string,
    large: PropTypes.bool,
    icon: PropTypes.string,
    inputRef: PropTypes.object,
    type: PropTypes.string,
    onKeyPress: PropTypes.func,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    showLoader: PropTypes.bool,
    wide: PropTypes.bool,
    reallyWide: PropTypes.bool,
    ultraWide: PropTypes.bool,
    fill: PropTypes.bool,
};